import { AutogenModelLocationOrderHistory, AutogenRowLocationOrderHistory } from "./autogen/AutogenModelLocationOrderHistory";

export class ModelLocationOrderHistory extends AutogenModelLocationOrderHistory<RowLocationOrderHistory> {
    constructor() {
        super(RowLocationOrderHistory);
    }
}

export class RowLocationOrderHistory extends AutogenRowLocationOrderHistory {
}